/**
 * The one way a page opens the concierge widget.
 *
 * The widget is mounted once, globally, above the router, and until now only
 * its own "Ask us" button could open it. The homepage invitation needs to open
 * it in interview mode from a button that lives in a different subtree, so
 * this is a window event rather than a context: no provider to thread through
 * pages that do not care, and nothing to mock in tests beyond `window`.
 */

export type ConciergeOpenMode = 'chat' | 'interview';

const EVENT_NAME = 'iv:concierge:open';

export function openConcierge(mode: ConciergeOpenMode = 'chat'): void {
  window.dispatchEvent(new CustomEvent<ConciergeOpenMode>(EVENT_NAME, { detail: mode }));
}

/** Subscribe; returns the unsubscribe. */
export function onConciergeOpen(handler: (mode: ConciergeOpenMode) => void): () => void {
  const listener = (event: Event): void => {
    const detail = (event as CustomEvent<ConciergeOpenMode>).detail;
    handler(detail === 'interview' ? 'interview' : 'chat');
  };
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
